import {
  API_DEFAULT_RETRIES,
  RequestId,
  RESOURCES_QUERY_URL,
} from 'appConstants';
import { Action, Dispatch } from 'redux';
import { ApiRequest, MiscUtils } from 'services';
import { AllTicketsDevices, Device } from 'types';

export interface TableViewAction extends Action {
  readonly showTableView?: boolean;
  readonly expandSearchInput?: boolean;
  readonly allTicketsDevices?: Device[];
}

export interface TableView {
  showTableView: boolean;
  expandSearchInput: boolean;
  allTicketsDevices: Device[];
}

const initialState = {
  showTableView: false,
  expandSearchInput: false,
  allTicketsDevices: [],
} as TableView;

enum Actions {
  TOGGLE_TABLE_VIEW = 'TOGGLE_TABLE_VIEW',
  EXPAND_SEARCH_INPUT = 'EXPAND_SEARCH_INPUT',
  SET_ALL_TICKETS_DEVICES = 'SET_ALL_TICKETS_DEVICES',
}

const toggleTableView = (showTableView: boolean): TableViewAction => ({
  type: Actions.TOGGLE_TABLE_VIEW,
  showTableView,
});

const setAllTicketsDevices = (
  allTicketsDevices: Device[],
): TableViewAction => ({
  type: Actions.SET_ALL_TICKETS_DEVICES,
  allTicketsDevices,
});

const toggleExpandSearchInput = (
  expandSearchInput: boolean,
): TableViewAction => ({
  type: Actions.EXPAND_SEARCH_INPUT,
  expandSearchInput,
});

const tableViewReducer = (state = initialState, action: TableViewAction) => {
  switch (action.type) {
    case Actions.TOGGLE_TABLE_VIEW:
      return {
        ...state,
        showTableView: !action.showTableView,
      };
    case Actions.EXPAND_SEARCH_INPUT:
      return {
        ...state,
        expandSearchInput: !action.expandSearchInput,
      };
    case Actions.SET_ALL_TICKETS_DEVICES:
      return {
        ...state,
        allTicketsDevices: action.allTicketsDevices,
      };
    default:
      return state;
  }
};

/** GET all tickets devices */
const getAllTicketsDevices = (
  allTicketsDevicesIds: string[],
  id: string,
) => async (dispatch: Dispatch<TableViewAction>) => {
  const onError = () => {
    /** Need to be updated as per requirement */
    MiscUtils.noop();
  };

  const onSuccess = (response: AllTicketsDevices) => {
    dispatch(setAllTicketsDevices(response.resources));
  };

  const accountId = id;
  const query = {
    resourceIDs: allTicketsDevicesIds,
    accountID: accountId,
  };

  return await ApiRequest.post(RESOURCES_QUERY_URL, query, {
    dispatchId: RequestId.GET_ALL_TICKETS_DEVICES,
    onSuccess,
    onError,
    retries: API_DEFAULT_RETRIES,
  });
};

export {
  tableViewReducer,
  toggleTableView,
  toggleExpandSearchInput,
  getAllTicketsDevices,
};
